import React from "react";
import "./ServicesShowcase.css";
import { useTranslation } from "react-i18next";
import {
  FaCar,
  FaHeartbeat,
  FaTools,
  FaPlane,
  FaShip,
  FaGlobe,
  FaUserTie,
} from "react-icons/fa";
import { GiStabbedNote, GiFireAxe } from "react-icons/gi";

const servicesData = [
  {
    key: "car",
    icon: <FaCar />,
    image:
      "https://cdn.pixabay.com/photo/2016/08/25/20/14/crash-test-1620591_960_720.jpg",
  },
  {
    key: "health",
    icon: <FaHeartbeat />,
    image:
      "https://cdn.pixabay.com/photo/2014/12/10/20/56/medical-563427_960_720.jpg",
  },
  {
    key: "contractors",
    icon: <FaTools />,
    image: "https://i.ibb.co/tJyGQ6L/Contractors-insurance-3.jpg",
  },
  {
    key: "fire",
    icon: <GiFireAxe />,
    image: "https://i.ibb.co/CHS7m22/fire.jpg",
  },
  {
    key: "expat",
    icon: <FaGlobe />,
    image:
      "https://images.pexels.com/photos/9462735/pexels-photo-9462735.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    key: "workmen",
    icon: <FaUserTie />,
    image:
      "https://images.unsplash.com/photo-1594581835488-0b95b8b0bacd?auto=format&fit=crop&w=1170&q=80",
  },
  {
    key: "political",
    icon: <GiStabbedNote />,
    image: "https://i.ibb.co/0fGDcj7/21-Aftermath-Of-The-Read-Only.jpg",
  },
  {
    key: "travel",
    icon: <FaPlane />,
    image:
      "https://cdn.pixabay.com/photo/2020/05/25/17/03/travel-5219496_960_720.jpg",
  },
  {
    key: "marine",
    icon: <FaShip />,
    image: "https://i.ibb.co/DggcsPF/cargo-ship.jpg",
  },
  {
    key: "civil",
    icon: <FaUserTie />,
    image: "https://i.ibb.co/4RHXNCY/careers.jpg",
  },
];

const ServicesShowcase = () => {
  const { t } = useTranslation();
  return (
    <section className="services-showcase">
      <div className="showcase-grid">
        {servicesData.map((s, i) => (
          <article
            className="service hidden"
            key={s.key}
            style={{ transitionDelay: `${20 * i}ms` }}
          >
            <div className="visual">
              <img src={s.image} alt={t(`services.${s.key}.title`)} />
            </div>
            <div className="meta">
              <div className="icon">{s.icon}</div>
              <h3>{t(`services.${s.key}.title`)}</h3>
              <p>{t(`services.${s.key}.short`)}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default ServicesShowcase;
